/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import { killshotApi } from '../../api';
import { createGroup, saveGroup, pushGroup } from '../../services/killshot';
import { DEFAULT_MARKETPLACE } from '../../helpers/constants';

export const fetchGroups = async () => {
  const response = await killshotApi.get('v1/groups/?event_id=3046733');
  return response;
};

export const setFocusedPricingGroupMarketplace = marketplace => ({
  type: 'SET_FOCUS_PRICING_GROUP_MARKETPLACE',
  marketplace,
});

export const setFocusedPricingGroupSection = focusedPricingGroup => ({
  type: 'FOCUS_PRICING_GROUP_SECTION',
  focusedPricingGroup,
});

export const setZones = zones => ({
  type: 'SET_ZONES',
  zones,
});

export const setVenues = venueData => ({
  type: 'SET_VENUES',
  venueData,
});

export const setFilteredStubhubListings = stubhubListings => ({
  type: 'SET_FILTERED_STUBHUB_LISTINGS',
  stubhubListings,
});

export const setFilteredTNListings = tnListings => ({
  type: 'SET_FILTERED_TN_LISTINGS',
  tnListings,
});

export const setTypeListing = typeListing => ({
  type: 'SET_TYPE_LISTING',
  typeListing,
});

export const setFormTNComparisonData = comparison => ({
  type: 'SET_FORM_TN_COMPARISON_DATA',
  comparison,
});

export const setHashComparisonData = (comparison, groupId, marketplace) => ({
  type: 'SET_HASH_COMPARISON_DATA',
  comparison,
  groupId,
  marketplace,
});

export const setHashTNComparisonData = (comparison, groupId, marketplace) => ({
  type: 'SET_HASH_TN_COMPARISON_DATA',
  comparison,
  groupId,
  marketplace,
});

export const setHashComparisonDataBulk = (comparison = {}, marketplace) => ({
  type: 'SET_HASH_COMPARISON_DATA_BULK',
  comparison,
  marketplace,
});

export const setHashTNComparisonDataBulk = (comparison = {}, marketplace) => ({
  type: 'SET_HASH_TN_COMPARISON_DATA_BULK',
  comparison,
  marketplace,
});

export const clearHashComparisonData = () => ({
  type: 'CLEAR_HASH_COMPARISON_DATA',
});

export const clearHashTNComparisonData = () => ({
  type: 'CLEAR_HASH_TN_COMPARISON_DATA',
});

export const setEventMeta = eventMeta => ({
  type: 'SET_EVENT_META',
  eventMeta,
});

export const setEventInfo = eventInfo => ({
  type: 'SET_EVENT_INFO',
  eventInfo,
});

export const setSkyboxId = skyboxId => ({
  type: 'SET_SKYBOX_ID',
  skyboxId,
});

export const toggleCreateGroupButton = disabled => ({
  type: 'TOGGLE_CREATE_GROUP_BUTTON',
  disabled,
});

export const inventoryRowsSelected = selectedInventoryRows => ({
  type: 'INVENTORY_SELECTED_ROWS',
  selectedInventoryRows,
});

export const setGroupAction = group => ({
  type: 'SET_GROUP',
  group,
});

export const selectedGroupAction = status => ({
  type: 'GROUP_SELECTED',
  status,
});

export const setGroup = group => dispatch => {
  if (group && Object.keys(group).includes('id')) {
    dispatch(selectedGroupAction(true));
  } else {
    dispatch(selectedGroupAction(false));
  }
  dispatch(setGroupAction(group));
};

export const setSplits = splits => ({
  type: 'SET_SPLITS',
  splits,
});

export const setGroupEditingId = groupEditingId => ({
  type: 'SET_EDITING_GROUP',
  groupEditingId,
});

export const setIsGroupContainerLoading = status => ({
  type: 'SET_IS_GROUP_CONTAINER_LOADING',
  status,
});

export const selectedGroupRanksComps = serverGroupsComps => ({
  type: 'SELECTED_GROUP_RANKS_COMPS',
  payload: serverGroupsComps,
});

export const handleInventoryRowsSelected = selectedInventoryRows => dispatch => {
  dispatch(toggleCreateGroupButton(!selectedInventoryRows || !selectedInventoryRows.length));
  dispatch(inventoryRowsSelected(selectedInventoryRows));
};

const getCanonicalName = (sectionName, zones) => {
  const canonicals = [];
  if (zones) {
    for (const zone of zones) {
      for (const section of zone.sections) {
        if (sectionName === section.name) {
          canonicals.push(section.canonical_name);
        }
      }
      if (canonicals.length > 0) {
        return canonicals;
      }
    }
  }
  return canonicals;
};

export const savePricingGroup = async (
  skyboxId,
  groupData,
  isMultiple,
  comparisonData = [],
  zones = [],
  typeListing = DEFAULT_MARKETPLACE,
  isTransfer = false,
  fromGroup = null,
  toGroup = null,
  updateListings = false,
  justSave = false
) => {
  try {
    if (isMultiple) {
      const bulkRequest = groupData.map(group => {
        const setIds = new Set();
        const nranks = [];

        group.ranks.forEach(d => {
          if (!setIds.has(d.skybox_listing_id)) nranks.push(d);
          else setIds.add(d.skybox_listing_id);
        });

        if (group.pricing_strategy_id === -1) {
          group.pricing_strategy_id = null;
        }
        group.update_listings = updateListings;
        return {
          ...group,
          tnd_sections:
            comparisonData.ticketnetwork && comparisonData.ticketnetwork[group.id]
              ? comparisonData.ticketnetwork[group.id].map(tn => ({
                  ...tn,
                  canonical_name: [tn.canonical_name],
                }))
              : [],
          sg_sections:
            comparisonData.seatgeek && comparisonData.seatgeek[group.id]
              ? comparisonData.seatgeek[group.id].map(sg => ({
                  ...sg,
                  canonical_name: [sg.canonical_name],
                }))
              : [],
          manual_price:
            comparisonData && comparisonData[typeListing] && comparisonData[typeListing][group.id]?.length
              ? undefined
              : group.manual_price,
        };
      });

      const pushGroupsPayload = {
        groupsInfo: bulkRequest,
        justSave,
      };

      if (justSave) {
        return saveGroup(skyboxId, pushGroupsPayload);
      }

      return pushGroup(skyboxId, pushGroupsPayload);
    }
    const setIds = new Set();
    const nranks = [];

    groupData[0].ranks.forEach(d => {
      if (!setIds.has(d.skybox_listing_id)) nranks.push(d);
      else setIds.add(d.skybox_listing_id);
    });

    groupData[0].ranks = nranks;

    if (groupData[0].pricing_strategy_id === -1) {
      groupData[0].pricing_strategy_id = null;
    }

    const newGroupData = {
      ...groupData[0],
      tnd_sections:
        comparisonData.ticketnetwork &&
        zones.ticketnetwork &&
        comparisonData.ticketnetwork.map(tn => ({
          ...tn,
          canonical_name: isTransfer ? [tn.canonical_name] : getCanonicalName(tn.section_name, zones.ticketnetwork),
        })),
      sg_sections:
        comparisonData.seatgeek &&
        zones.seatgeek &&
        comparisonData.seatgeek.map(sg => ({
          ...sg,
          canonical_name: isTransfer
            ? [sg.canonical_name]
            : getCanonicalName(sg.section_name.toUpperCase(), zones.seatgeek),
        })),
      marketplace: [typeListing],
    };

    if (newGroupData?.sections?.length) {
      delete newGroupData.manual_price;
    }
    newGroupData.isTransfer = isTransfer;
    if (fromGroup) {
      const { id, name } = fromGroup;
      newGroupData.fromGroupId = id;
      newGroupData.fromGroupName = name;
    }
    if (toGroup) {
      const { id, name } = toGroup;
      newGroupData.toGroupId = id;
      newGroupData.toGroupName = name;
    }
    newGroupData.update_listings = updateListings;
    return createGroup(skyboxId, [newGroupData]);
  } catch (err) {
    throw err;
  }
};

export const filterStubhubListings = (focusedPricingGroupId, currSplit) => (dispatch, getState) => {
  const { pricingGroups, currComparisonSections, stubhubListings } = getState().pricing;
  const currPricingGroup = pricingGroups.find(group => group.id === focusedPricingGroupId);
  const splits = currSplit || currPricingGroup.splits;
  const filteredStubhubListings = stubhubListings.filter(
    listing =>
      currComparisonSections.some(comp => comp.section_name === listing.section_name) &&
      splits.some(split => listing.split_vector.indexOf(split) > -1 || split === 'All') &&
      !listing.is_ours
  );
  dispatch(setFilteredStubhubListings(filteredStubhubListings));
};

export const filterTNListings = (focusedPricingGroupId, currSplit) => (dispatch, getState) => {
  const { pricingGroups, currComparisonSections, stubhubListings } = getState().pricing;
  const currPricingGroup = pricingGroups.find(group => group.id === focusedPricingGroupId);
  const splits = currSplit || currPricingGroup.splits;
  const filteredStubhubListings = stubhubListings.filter(
    listing =>
      currComparisonSections.some(comp => comp.section_name === listing.section_name) &&
      splits.some(split => listing.split_vector.indexOf(split) > -1 || split === 'All') &&
      !listing.is_ours
  );
  dispatch(setFilteredTNListings(filteredStubhubListings));
};
